import angular from 'angular';
import moment from 'moment';

(function() {
    'use strict';

    angular.module('app').component('feedback', {
        template: require('./feedback.html'),
        controller: Controller,
        controllerAs: 'vm',
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }
    });

    Controller.$inject = [
        '$rootScope',
        '$state',
        '$cookies',
        '$scope',
        '$stateParams',
        '$filter',
        'QueryService',
        'logger'
    ];

    function Controller(
        $rootScope,
        $state,
        $cookies,
        $scope,
        $stateParams,
        $filter,
        QueryService,
        logger
    ) {
        const vm = this;
        vm.hello_teacher = require('Images/hello_teacher.png');

        const keys = {
            Grammar:{
                key: 'feedback_grammar',
                title: 'error',
                sub: 'correction',
                title_message: 'Your Sentence',
                sub_message: 'Better Say'
            },
            Pronunciation:{
                key: 'feedback_pronunciation',
                title: 'error',
                sub: 'correction',
                title_message: 'Words To Practice',
                sub_message: 'Comments / Suggestions'
            },
            Vocabulary:{
                key: 'feedback_vocabulary',
                title: 'tips',
                sub: 'new',
                title_message: 'New Vocabulary / Expression',
                sub_message: 'When to Say it / Example Sentence'
            },
        }
        vm.key_setup = keys;

        function setup_keys(){

            vm.keys = [];
            Object.keys(keys).forEach(k => {
                const _key = {
                    key: k,
                    contents: []
                }
                
                for(let i = 1; i < 4; i++){
                    const title = keys[k].key + '_' + keys[k].title + '_' + i;
                    const sub = keys[k].key + '_' + keys[k].sub + '_' + i;
                    if(vm.data[title]){
                        _key.visible = true;
                        _key.contents.push(vm.key_setup[k].title_message + ': ' + vm.data[title]);
                    }
                    if(vm.data[sub]){
                        _key.visible = true;
                        _key[sub] = vm.data[sub];
                        _key.contents.push(vm.key_setup[k].sub_message + ': ' + vm.data[sub]);
                    }

                }
                const comment = keys[k].key + '_comment';
                if(vm.data[comment]){
                    _key.visible = true;
                    _key.comment = vm.data[comment];
                }

                vm.keys.push(_key);
            });
            console.log(vm.keys)
        }

        vm.format = (date, format) => {
            return moment(date)
                .utcOffset(9)
                .format(format);
        };

        // get_data();
        function get_data() {
            const params = {};
            vm.loading = true;
            var request = {
                method: 'GET',
                params,
                route: {
                    feedback: $stateParams.id
                },
                cache_string: ''
            };

            QueryService.query(request).then(
                function(response) {
                    vm.data = response.data.data.items[0];
                    console.log(vm.data);
                    setup_keys();
                },
                function(err) {}
            );
        }

        //-------------------- start canvas --------------------
        const pi = Math.PI;
        vm.settings = {
            star_size: 10,
            star_inner_size: 6.5,
            star_color: 'gold',

            arc_extra_length: pi / 5.2,
            arc_width: 25,
            arc_border_width: 10,
            arc_border_color: '#686963',
            arc_color: '#E3F2FD',
            arc_score_color: '#5998C5',
            arc_sections: 10,
            arc_size: 0, // w/3
            arc_line_cap: 'round', //butt, round,

            arc_ghost_life: 100,
            arc_ghost_color: '#FFF689',
            confetti_group: 15,
            confetti_count: 300,
        }
        const s = vm.settings;
        //set up
        const canvas = document.getElementById('canvas');
        const w = window.innerWidth;
        const h = window.innerWidth;
        canvas.width = w;
        canvas.height = h;
        s.arc_size = w / 3;
        const ctx = canvas.getContext('2d');
        // end set up
        vm.draw_arc = draw_arc;
        vm.score_int = 0;
        vm.score = 0;
        vm.target_score = 0.50;
        let fsize_offset = 0;
        let fsize_v = 0;
        let fsize_gravity = 10;

        const arc_ghosts = [];
        const arc_confettis = [];
        requestAnimationFrame(draw); 
        
        function draw(){
            ctx.clearRect(0, 0, w, w);
            
            arc_confettis.forEach(c => {
                draw_confetti(c);
            });

            draw_arc(vm.score);
            let score_v = (vm.target_score - vm.score) * 0.015;
            if(score_v < 0.0025){
                score_v = 0.0025;
            }

            if(score_v > 0.015){
                score_v = 0.015
            }
            vm.score += score_v;

            if(vm.score > vm.target_score){
                vm.score = vm.target_score;
            }

            if(vm.score == vm.target_score){
                if(arc_confettis.length < s.confetti_count){
                    for(let i = 0; i < s.confetti_group; i++){
                        const angle = Math.random() * pi;
                        const v = Math.random() * 15 + 5;
                        const randx = Math.random() * w / 10;
                        const randy = Math.random() * w / 10;
                        const vx = Math.cos(angle) * v;
                        const vy = -Math.sin(angle) * v;
                        const r = Math.random() * pi * 2;
                        const rv = (Math.random() * 2 - 1) * 0.3;
                        const ro = Math.random() * 10;
                        const sv = (Math.random() * 2 - 1) * 0.3;
                        const s = Math.random()*2;
                        const color = `hsl(${ Math.random() * 360}, 80%, 56%)`;
                        const _w = Math.random() * 10 + 4;
                        const _h = Math.random() * 10 + 4;
                        const c = {
                            x: w / 2 + randx - 12,
                            y: w / 2 + randy,
                            w: _w,
                            h: _h,
                            r,
                            rv,
                            ro,
                            s,
                            sv,
                            vx,
                            vy,
                            color,
                            linecap: Math.random() < 0.025?'round':'butt'
                        }

                        arc_confettis.push(c);
                    }
                }
            }

            if(Math.floor(vm.score * s.arc_sections) != Math.floor(vm.score_int)){
                vm.score_int = Math.floor(vm.score * s.arc_sections);
                fsize_gravity = 0.5;
                fsize_offset = 30;

                const ghost = {
                    index: vm.score_int,
                    life: s.arc_ghost_life
                }

                arc_ghosts.push(ghost);
            }

            if(fsize_offset > 0){
                fsize_offset += fsize_v;
                fsize_v -= fsize_gravity;
            }else{
                fsize_offset = 0;
                fsize_gravity = 0;
                fsize_v = 0;
            }

            if(fsize_offset < 0){
                fsize_offset = 0;
            }
            const _fsize = (1 - (vm.target_score - vm.score));
            const fsize = w/8+_fsize*100 + fsize_offset;
            ctx.font = `bold ${ fsize }px calibri`;
            ctx.fillStyle = lerpColor('#4C5C68', '#1985A1', Math.min(1.0 ,Math.max(0, fsize_offset/30)));
            // const text = Math.floor(vm.score * s.arc_sections);
            const text = (vm.score * s.arc_sections).toFixed(1);
            // const text = fsize_offset.toFixed(2)
            const text_width = ctx.measureText(text).width;
            ctx.fillText(text,w/2 - text_width / 2, w/2 + fsize / 2 - 30);
            
            // draw ghosts
            arc_ghosts.forEach(ghost => {
                draw_arc_ghost(ghost);
            });
            requestAnimationFrame(draw); 
        }
        function draw_confetti(c){
            c.x += c.vx;
            c.y += c.vy;
            c.vy += 0.3;
            c.vx *= 0.95;

            const scale = Math.sin(c.s);
            c.s += c.sv;
            c.r += c.rv;

            // ctx.fillStyle = c.color;
            // ctx.save();
            // const tx = c.x+c.w/2 * scale;
            // const ty = c.y+c.h/2;
            // ctx.translate(tx, ty);
            // ctx.rotate(c.r)
            // ctx.fillRect(c.ro, 0, c.w * scale, c.h);
            // ctx.translate(-tx, -ty);
            // ctx.restore();

            ctx.lineCap = c.linecap;
            ctx.strokeStyle = c.color;
            ctx.lineWidth = c.w;
            
            const dx = Math.cos(c.r) * c.h / 2 * scale;
            const dy = Math.sin(c.r) * c.h / 2 * scale;

            const x1 = c.x - dx;
            const y1 = c.y - dy;
            const x2 = c.x + dx;
            const y2 = c.y + dy;

            ctx.beginPath();
            ctx.moveTo(x1,y1);
            ctx.lineTo(x2,y2);
            ctx.stroke();

        }
        function draw_arc_ghost(ghost){
            ghost.life -= 7;
            const arc_len = pi + 2 * s.arc_extra_length;
            const _s = pi - s.arc_extra_length + (ghost.index - 1) * arc_len / s.arc_sections;
            const _e = pi - s.arc_extra_length + (ghost.index) * arc_len / s.arc_sections;
            const _a = ghost.life / s.arc_ghost_life;
            ctx.lineCap = 'butt';
            // ctx.strokeStyle = `rgba(255,250,55,${ _a/1.5 })`;
            ctx.strokeStyle = s.arc_ghost_color + getHex(Math.max(0, Math.min(parseInt(_a/1.5 * 255), 255)));
            ctx.lineWidth = s.arc_width;
            ctx.lineWidth = s.arc_width + s.arc_border_width + (1 - _a)*15;
            ctx.beginPath();
            ctx.arc(w/2, w/2, s.arc_size, _s, _e);
            ctx.stroke();

        }

        function draw_arc(score){
            ctx.lineCap = s.arc_line_cap;
            ctx.strokeStyle = s.arc_border_color;
            ctx.lineWidth = s.arc_width + s.arc_border_width;
            ctx.beginPath();
            ctx.arc(w/2, w/2, s.arc_size, pi - s.arc_extra_length, pi * 2 + s.arc_extra_length);
            ctx.stroke();
            
            ctx.strokeStyle = s.arc_color;
            ctx.lineWidth = s.arc_width;
            ctx.beginPath();
            ctx.arc(w/2, w/2, s.arc_size, pi - s.arc_extra_length, pi * 2 + s.arc_extra_length);
            ctx.stroke();

            //draw score bar
            
            ctx.strokeStyle = s.arc_score_color;
            ctx.lineWidth = s.arc_width;
            ctx.beginPath();
            ctx.arc(w/2, w/2, s.arc_size, pi - s.arc_extra_length, pi - s.arc_extra_length + (pi+s.arc_extra_length*2)* score);
            ctx.stroke();


            //draw sections
            const _s = s.arc_line_cap == 'round'?1:0;
            const _e = s.arc_sections + (s.arc_line_cap == 'round'?0:1);
            for(let i = _s; i < _e; i++){
                const angle_increment = pi + 2 * s.arc_extra_length; 
                const angle = pi - s.arc_extra_length + angle_increment / s.arc_sections * i;

                let compensation = s.arc_line_cap == 'round'?0:s.arc_border_width / 2;
                const x1 = Math.cos(angle) * (s.arc_size - s.arc_width / 2 - compensation);
                const y1 = Math.sin(angle) * (s.arc_size - s.arc_width / 2 - compensation);

                const x2 = Math.cos(angle) * (s.arc_size + s.arc_width / 2 + compensation);
                const y2 = Math.sin(angle) * (s.arc_size + s.arc_width / 2 + compensation);
                
                ctx.strokeStyle = s.arc_border_color;
                ctx.lineWidth = s.arc_border_width / 2;
                ctx.beginPath();
                ctx.moveTo(w / 2 + x1, w / 2 + y1);
                ctx.lineTo(w / 2 + x2, w / 2 + y2);
                ctx.stroke();

            }
        }

        function draw_star(ctx, x, y, scale){
            const _w = w * (scale || 1) / 100;
            ctx.fillStyle = s.star_color;
            ctx.beginPath();
            ctx.moveTo(x, y);

            for(let i = 0; i <= 10 ; i++){
                const angle = 2 * pi * i / 10 - pi/2; 
                const size = (i % 2 == 0)?s.star_size: s.star_inner_size;
                const _x = Math.cos(angle) * size * _w;
                const _y = Math.sin(angle) * size * _w;

                ctx.lineTo(x+_x - _w / 2, y+_y - _w / 2);
            }
            ctx.closePath();
            ctx.fill();
        }
        
        function lerpColor(a, b, amount) { 

            var ah = parseInt(a.replace(/#/g, ''), 16),
                ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff,
                bh = parseInt(b.replace(/#/g, ''), 16),
                br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff,
                rr = ar + amount * (br - ar),
                rg = ag + amount * (bg - ag),
                rb = ab + amount * (bb - ab);
        
            return '#' + ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1);
        }

        const getHex = i => ('00' + i.toString(16)).slice(-2);
        //end
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/view-feedback/feedback-modal.component.js